
import $ from 'jquery';

function FormSaveLink(props) {
  return (
    <form action="#" method="post">
        <textarea className="form-control" rows="3" name="url" style={{width: "350px"}} required placeholder="Paste URL here"></textarea>
        <button type="submit" className="btn btn-primary">Submit</button>
    </form>
  );
}

export function initFormSaveLink(dom) {
  
};

export default FormSaveLink;
